// liuxu
// 天气
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node, CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // 浏览器全局变量(root 即 window)
        root.computationTime = factory(root.jQuery);
    }
}(this, function ($) {
  var weather = {
    /**
     * 构建天气预报结构.
     */
    buildWeatherDetail: function () {
      var T = this;
      var str = '<div class="fl top_weather" id="toolbarTopWeather" log_action="598a758fec6e0f76098ffa69">' +
                  '<div class="top_data">' +
                    '<div id="jToolbarWeather">' +
                      '<a rel="external nofollow" href="javascript:void(0)"><span id="w_city"></span><span id="w_img"></span><span id="w_weather"></span><span id="w_temper"></span></a>' +
                      '<a rel="external nofollow" href="javascript:void(0)" class="air_quality"></a>' +
                    '</div>' +
                  '</div>' +
                  '<div class="weather_con" id="weather_detail">' +
                    '<a class="weather_seven" href="" target="_blank">未来七天天气</a>' +
                    '<div class="weather_title"><i>'+T.getDate(0)+'</i><span class="weather_city"></span><a href="javascript:;" class="weather_change">切换城市</a></div>' +
                    '<div class="weather_select" style="display:none"><select class="province" id="s_province"></select><select class="city" id="s_city"></select><select class="county" id="s_county"></select><input type="button" id="weatherSubmit" class="ok" value="更换"></div>' +
                    '<div class="weather_day"></div>' +
                    '<div class="weather_list clearb"></div>' +
                  '</div>' +
                '</div>';
      return str;
    },
    /**
     * 获取省市区数据.
     */
    getProvinceDate: function () {
      var T = this;
      $.ajax({
        type: 'GET',
        url: '/v5/general/v1/public/citylist?order=province',
        dataType: 'json',
        contentType: "application/x-www-form-urlencoded;charset=UTF-8",
        timeout: 30000,
        success: function (data) {
          T.provinceData = data.data;
          var provinceHTML = '';
          for(var key in T.provinceData) {
            provinceHTML += '<option value="'+ key +'"';
            if(key == T.curProvince) {
              provinceHTML += ' selected="selected"';
            }
            provinceHTML += '>' + key + '</option>';
          }
          $('#s_province').html(provinceHTML);
          T.cityData = T.provinceData[T.curProvince];
          T.countyData = T.provinceData[T.curProvince][T.curCity];
          T.buildCity();
          T.buildCounty();
          // $('#s_province option[value = '+T.curProvince+']').attr('selected','selected');
        },
        error: function (xhr, type) {
          console.log("error")
        }
    });
    },
    buildCity: function () {
      var T = this;
      var cityHTML = '';
      for(var key in T.cityData) {
        cityHTML += '<option value="'+ key +'"';
        if(key == T.curCity) {
          cityHTML += ' selected="selected"';
        }
        cityHTML += '>' + key + '</option>';
      }
      $('#s_city').html(cityHTML);
      // if(T.curCity){
      //   $('#s_city option[value='+T.curCity+']').attr('selected','selected');
      // } else {
      //   $('#s_city option:eq(0)').attr('selected','selected');
      // }
    },
    buildCounty: function () {
      var T = this;
      var countyHTML = '<option value="'+T.curCity+'" data-code="'+ T.countyData.citycode +'">'+T.curCity+'</option>';
      console.log(T.countyData.list);
      for(var i = 0; i < T.countyData.list.length; i++) {
        var countyItem = T.countyData.list[i];
        countyHTML += '<option value="'+ countyItem.town +'" data-code="'+ countyItem.towncode +'"';
        if(countyItem.town == T.curCounty) {
          countyHTML += ' selected="selected"';
        }
        countyHTML += '>' + countyItem.town + '</option>';
      }
      $('#s_county').html(countyHTML);
      // if(T.curProvince){
      //   $('#s_county option[value = '+T.curProvince+']').attr('selected','selected');
      // } else {
      //   $('#s_county option:eq(0)').attr('selected','selected');
      // }
    },
    /**
     * 获取城市天气数据.
     * * @param city 城市名称
     */
    getWeatherDate: function () {
      var T = this;
      $.ajax({
        type: 'GET',
        url: '/v5/general/v1/public/weather?code=' + T.curCode + '&days=' + T.day,
        dataType: 'json',
        contentType: "application/x-www-form-urlencoded;charset=UTF-8",
        timeout: 30000,
        success: function (data) {
          var weathrInfo = data.data;
          var qualityCss = '';
          var toadyHtml = '';
          var threeDayHtml = '';
          if(weathrInfo.aqiInfo.quality){
            if(weathrInfo.aqiInfo.quality == '优'){
              qualityCss = 'you';
            } else if(weathrInfo.aqiInfo.quality == '良'){
              qualityCss = 'liang';
            } else if(weathrInfo.aqiInfo.quality == '轻度污染'){
              qualityCss = 'qingdu';
            } else if(weathrInfo.aqiInfo.quality == '中度污染'){
              qualityCss = 'zhongdu';
            } else if(weathrInfo.aqiInfo.quality == '重度污染'){
              qualityCss = 'zhongdu2';
            } else if(weathrInfo.aqiInfo.quality == '严重污染'){
              qualityCss = 'yanzhong';
            }
          }
          // 头部天气显示
          $('#w_city').text(weathrInfo.city);
          $('#w_img').html('<img src="'+ weathrInfo.real.weather_icon +'">');
          $('#w_weather').text(weathrInfo.real.weather);
          $('#w_temper').text(weathrInfo.real.temper+'℃');
          $('.air_quality').html('<em class="'+ qualityCss+'">' + weathrInfo.aqiInfo.quality + '</em>');
          //浮层天气显示
          $('.weather_city').text(weathrInfo.city);
          $('.weather_seven').attr('href', 'http://www.weather.com.cn/weather/'+ weathrInfo.weathercode +'.shtml');
          toadyHtml = '<a href="javascript:void(0)"><div class="weather_day_l">'+
                            '<img src="'+ weathrInfo.weatherList[0].day.weather_icon[0] +'">'+
                            '<span class="feature">'+ weathrInfo.weatherList[0].day.weather +'</span></div>'+
                          '<div class="weather_day_wrap">'+
                            '<span class="weather">'+ weathrInfo.weatherList[0].day.temper +'~'+ weathrInfo.weatherList[0].night.temper +'℃</span>'+
                            '<span class="quality '+ qualityCss +'">'+
                              '<i class="quality_digit">'+ weathrInfo.aqiInfo.value +'</i>'+
                              '<i class="quality_degree">'+ weathrInfo.aqiInfo.quality +'</i></span>'+
                            '<span class="wind">'+ weathrInfo.weatherList[0].day.wind_direction +'</span>'+
                          '</div>'+
                        '</a>';
          $('.weather_day').html(toadyHtml);
          for(var i=1; i<T.day; i++){
            var dayText = '';
            if(i==1){
              dayText = '明天';
            } else if(i==2) {
              dayText = '后天';
            } else {
              dayText = T.getDate(i);
            }
            threeDayHtml += '<a href="javascript:void(0)">' +
                              '<div>'+ dayText +'</div>' +
                              '<img src="'+weathrInfo.weatherList[i].day.weather_icon[0]+'">' +
                              '<div>'+weathrInfo.weatherList[i].day.weather+'</div>' +
                              '<div>'+ weathrInfo.weatherList[i].day.temper +'~'+ weathrInfo.weatherList[i].night.temper +'℃</div>' +
                            '</a>';
          }
          $('.weather_list').html(threeDayHtml);
        },
        error: function (xhr, type) {
          console.log("error")
        }
    });
    },
    /**
     * 获取n天后类似12月1日的格式的日期.
     * @param dayn n天后
     * @returns {*}
     */
    getDate: function (dayn) {
      var date = new Date;
      date.setDate(date.getDate()+dayn);
      var mouth = date.getMonth() + 1;
      var day = date.getDate();
      return mouth + '月' + day + '日';
    },
    init: function () {
        var T = this;
        T.day = 4;
        T.provinceData;
        T.cityData;
        T.countyData;
        T.hoverTimer;
        if(typeof $.cookie('__WWW_CITY__') === 'undefined'){
          T.curProvince ='北京';
          T.curCity = '北京';
          T.curCounty = '北京';
          T.curCode = '110000';
        } else {
          var cityList = $.cookie('__WWW_CITY__').split(",");
          T.curProvince = cityList[0];
          T.curCity = cityList[1];
          T.curCounty = cityList[2];
          T.curCode = cityList[3];
        }
        $('#chinaso_weather').html(T.buildWeatherDetail());
        T.getWeatherDate();
        T.getProvinceDate();
        $('#toolbarTopWeather').hover(function(){
          T.hoverTimer = setTimeout( function() {
            console.log("weather-show1");
            $('.weather_con').show();
          }, 200 );
        }, function(){
          // console.log("weather-hide");
          // $('.weather_con').hide();
          clearTimeout(T.hoverTimer);
        });
        $('.weather_change').on('click', function(){
          $(".weather_select").show();
        });
        $("#s_province").on("change", function(){
          $('#s_county').html('');
          T.curProvince = $(this).val();
          T.cityData = T.provinceData[T.curProvince];
          T.buildCity();
          for(var key in T.cityData) {
            T.curCity = key;
            break;
          }
          T.countyData = T.provinceData[T.curProvince][T.curCity];
          T.buildCounty();
        });
        $("#s_city").on("change", function(){
          T.curCity = $(this).val();
          T.countyData = T.provinceData[T.curProvince][T.curCity];
          T.buildCounty();
        });
        $('#weatherSubmit').on('click', function() {
          if($("#s_county").val() !=''){
            $(".weather_select").hide();
            T.curCounty = $("#s_county option:selected").val();
            T.curCode = $("#s_county option:selected").data('code');
            T.getWeatherDate();
            $.cookie('__WWW_CITY__', T.curProvince+','+T.curCity + ',' +T.curCounty +','+T.curCode, { expires: 365 });
          }
        });
        // $('#chinaso_weather select').on("change,hover", function(){
        //   console.log("weather-show2");
        //   setTimeout(function(){
        //     console.log("weather-show2");
        //     $('.weather_con').show();
        //   },10)
        // });
        // $('#chinaso_weather select option').on("focus", function(){
        //   console.log("weather-show3");
        //   $('.weather_con').show();
        // });
        document.addEventListener('click',function (e) {
          var parent=$(e.target).parents('#chinaso_weather');         
          if(parent.length===0){
            $('.weather_con').hide();
          }else{
          console.log('天气区域')
          }
         })
    }
  }
  return weather;
}))



//////////////////
// WEBPACK FOOTER
// ./static/v4/js/weather.js
// module id = 1d5b37c4c2ed46f36bed
// module chunks = 1